import React, { useCallback, useState } from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import { FormattedMessage, injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { FormControl } from 'react-bootstrap';
import { change, reduxForm } from "redux-form";

import Loader from "../Common/Loader/Loader";
import ShowDescription from '../ShowDescription/ShowDescription';

import { api, promoCodeImageUploadDir } from "../../config";
import messages from "../../locale/messages";
import submit from "./submit";

import noPromoIcon from '/public/Icons/defaultNoResultIcon.svg';
import defaultPromoSearchIcon from '/public/Icons/defaultPromoSearchIcon.svg';

import bt from '../../components/commonStyle.css';
import s from './PromoCodeForm.css';

function PromoCodeForm({ handleSubmit, promoCodeData, intl: { formatMessage } }) {

    const [promoCode, setPromoCode] = useState('');
    const dispatch = useDispatch();
    const loading = useSelector(state => state.loader.applyPromo);

    const promoCodes = promoCodeData?.getPromoCodes?.results;

    const handleInputChange = useCallback((event) => {
        const inputValue = event.target.value;
        setPromoCode(inputValue);

        const validCode = promoCodes?.find((item) => item.code === inputValue);
        dispatch(change('PromoCodeForm', 'promoCode', inputValue));
        dispatch(change('PromoCodeForm', 'promoId', validCode ? validCode.id : null));
    });

    const handlePrefill = useCallback((code, id) => {
        setPromoCode(code);
        dispatch(change('PromoCodeForm', 'promoCode', code));
        dispatch(change('PromoCodeForm', 'promoId', id));
    });

    return (
        <>
            <form onSubmit={handleSubmit(submit)}>
                <div className={s.promoCodeInputContainer}>
                    <div className={cx('promoCodeSearchInputContainer', 'svgImg')}>
                        <img src={defaultPromoSearchIcon} alt="promoSearchIcon" className={cx(s.promoSearchIcon, 'promoSearchIconRtl')} />
                        <FormControl
                            type="text"
                            placeholder={formatMessage(messages.promoCodeSearch)}
                            value={promoCode}
                            onChange={handleInputChange}
                            className={bt.formControlInput}
                        />
                    </div>
                    <Loader
                        type={"button"}
                        buttonType={"submit"}
                        show={loading}
                        label={formatMessage(messages.applyLabel)}
                        className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                    />
                </div>
                {promoCodes?.length > 0 && (
                    <div className={cx(bt.commonSize18, bt.fontWeight600, bt.primaryColor, bt.space2, bt.textAlignStart)}>
                        <FormattedMessage {...messages.promoCodeOffers} />
                    </div>
                )}
                {promoCodeData?.loading && <Loader type="circle" show={true} />}
                {!promoCodeData?.loading && promoCodes?.length > 0 && (
                    <div className={s.promoCodeCardList}>
                        {promoCodes.map((item, index) => (
                            <div key={index} onClick={() => handlePrefill(item.code, item.id)} className={s.promoCodeCardListItem}>
                                <span className={s.promoCodeCardLsImgContainer}>
                                    <img
                                        src={`${api.apiEndpoint}${promoCodeImageUploadDir}medium_${item.imageName}`}
                                        alt={item.title}
                                    />
                                </span>
                                <div>
                                    <h4 className={cx(bt.commonSize14, bt.fontWeight700, bt.primaryColor, bt.space0, bt.textAlignStart)}>{item.title}</h4>
                                    <ShowDescription
                                        description={item.description}
                                        count={250}
                                        containerClass={bt.space1}
                                        className={cx(bt.commonSize14, bt.fontWeight400, bt.secondaryColor, bt.space0, bt.textAlignStart)}
                                    />
                                    <p className={cx(bt.commonSize14, bt.fontWeight600, bt.themeColor, bt.space0, bt.textAlignStart, 'd-flex')}>
                                        <span className={cx(bt.displayInlineBlock, s.promoCodeLabel)}>
                                            <FormattedMessage {...messages.codeLabel} />&nbsp;
                                        </span>
                                        <span className={bt.displayInlineBlock}>{item.code}</span>
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {!promoCodeData?.loading && promoCodes?.length === 0 && (
                    <div>
                        <img src={noPromoIcon} alt="noPromoIcon" className={s.noPromoDefaultIcon} />
                        <p className={cx(bt.fontWeight400, bt.commonSize16, bt.secondaryColor, bt.textAlignCenter, bt.space0)}>
                            {formatMessage(messages.noPromoCode)}
                        </p>
                    </div>
                )}
            </form>
        </>
    );
};

PromoCodeForm = reduxForm({
    form: 'PromoCodeForm',
    destroyOnUnmount: false,
    onSubmit: submit
})(PromoCodeForm);

export default injectIntl(withStyles(bt, s)(PromoCodeForm));
